import type { ColumnDef } from "@tanstack/react-table";
import type { Dosen } from "../api/get-dosen";

export const columns: ColumnDef<Dosen>[] = [
  {
    accessorKey: 'nama',
    header: 'Nama',
  },
  {
    accessorKey: 'nip',
    header: 'NIP',
  },
  {
    accessorKey: 'nidn',
    header: 'NIDN',
  },
  {
    accessorKey: 'email',
    header: 'Email',
  },
];
